/* =========================================================================
   ORIVA — attribution de la page d'entrée

   Le problème : Shopify sait compter les sessions par page d'atterrissage, mais
   il ne relie pas la commande à la page qui l'a déclenchée. Sans ce lien, on
   compare des visites et des ventes sans jamais pouvoir diviser l'une par
   l'autre.

   Ce que fait ce script : il retient la PREMIÈRE page de la session, et il
   l'écrit dans les attributs du panier. Shopify recopie ces attributs sur la
   commande. Le taux de conversion d'une page devient alors une division :

       commandes portant « Entrée = /blogs/dossier/av1 »
       ─────────────────────────────────────────────────
       sessions atterries sur /blogs/dossier/av1

   Deux précautions :
   · la première page seulement — sinon la dernière page vue écraserait la
     vraie origine, et toutes les ventes seraient attribuées au produit ;
   · un seul appel réseau par session.
   ========================================================================= */

(function () {
  'use strict';

  var CLE_ENTREE = 'oriva_entree';
  var CLE_ENVOYE = 'oriva_entree_envoyee';

  function lire(cle) { try { return sessionStorage.getItem(cle); } catch (e) { return null; } }
  function ecrire(cle, val) { try { sessionStorage.setItem(cle, val); } catch (e) {} }

  /* 1. La page d'entrée : on ne l'écrase jamais. */
  var entree = lire(CLE_ENTREE);
  if (!entree) {
    entree = location.pathname;
    var src = new URLSearchParams(location.search).get('src');
    if (src) entree += ' (' + src + ')';
    ecrire(CLE_ENTREE, entree);
    ecrire('oriva_referent', document.referrer || 'direct');
  }

  /* 2. On l'attache au panier, une seule fois par session. */
  if (lire(CLE_ENVOYE) === entree) return;

  var attributs = {
    'Entrée': entree,
    'Référent': lire('oriva_referent') || 'direct'
  };
  var profil = lire('oriva_profil');
  if (profil) attributs['Profil quiz'] = profil;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributs })
  }).then(function () {
    ecrire(CLE_ENVOYE, entree);
  }).catch(function () {
    /* Panier indisponible : on réessaiera à la page suivante. Rien à signaler
       au visiteur — l'attribution est un outil interne, pas une fonctionnalité. */
  });
})();
